//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    content: {
      required: true,
    },
    data: {
      required: true,
    },
    cta: {
      required: true,
    },
    selectedState: {
      required: false,
      default: "1",
    },
  },

  computed: {},
};
